module.exports = __webpack_public_path__ + "img/venus7.8604a91e.png";